<div class="card border shadow-none mb-0">
  <div class="card-body">
    <h5 class="card-title mb-3">
      <i class="mdi mdi-code-json me-1 text-primary"></i>{{ title() }}
    </h5>

    @if (hasPayload()) {
      <pre class="payload-json mb-0">{{ formatted() }}</pre>
    } @else {
      <p class="text-muted font-size-13 mb-0">
        <i class="mdi mdi-information-outline me-1"></i>{{ emptyMessage() }}
      </p>
    }
  </div>
</div>
